var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("img", {
    attrs: { src: require(`@/assets/svg/chips/${_vm.chip}.svg`) },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }